'use client';
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = Dialog;
exports.DialogTitle = DialogTitle;
exports.DialogDescription = DialogDescription;
exports.DialogBody = DialogBody;
exports.DialogActions = DialogActions;
const jsx_runtime_1 = require("react/jsx-runtime");
const Headless = __importStar(require("@headlessui/react"));
const clsx_1 = require("clsx");
const text_1 = require("./text");
const sizes = {
    xs: 'sm:max-w-xs',
    sm: 'sm:max-w-sm',
    md: 'sm:max-w-md',
    lg: 'sm:max-w-lg',
    xl: 'sm:max-w-xl',
    '2xl': 'sm:max-w-2xl',
    '3xl': 'sm:max-w-3xl',
    '4xl': 'sm:max-w-4xl',
    '5xl': 'sm:max-w-5xl'
};
// Modal surface: 24px radius (the signature), --aiq-shadow-pop, neutral-tinted backdrop.
// Mobile docks to bottom with rounded top corners. Desktop centers with breathing room.
function Dialog(_a) {
    var { size = 'lg', className, children, zIndex, panelProps } = _a, props = __rest(_a, ["size", "className", "children", "zIndex", "panelProps"]);
    return ((0, jsx_runtime_1.jsxs)(Headless.Dialog, Object.assign({}, props, { children: [(0, jsx_runtime_1.jsx)(Headless.DialogBackdrop, { className: 'fixed inset-0 flex w-screen justify-center overflow-y-auto bg-neutral-900/40 px-2 py-2 transition duration-100 focus:outline-0 data-closed:opacity-0 data-enter:ease-out data-leave:ease-in sm:px-6 sm:py-8 lg:px-8 lg:py-16', style: { zIndex }, transition: true }), (0, jsx_runtime_1.jsx)("div", { className: 'fixed inset-0 w-screen overflow-y-auto pt-6 sm:pt-0', style: { zIndex }, children: (0, jsx_runtime_1.jsx)("div", { className: 'grid min-h-full grid-rows-[1fr_auto] justify-items-center sm:grid-rows-[1fr_auto_3fr] sm:p-4', children: (0, jsx_runtime_1.jsx)(Headless.DialogPanel, Object.assign({}, panelProps, { className: (0, clsx_1.clsx)(className, sizes[size], 'row-start-2 w-full min-w-0 rounded-t-2xl border border-neutral-100 bg-surface p-(--gutter) shadow-pop [--gutter:--spacing(8)] sm:mb-auto sm:rounded-2xl forced-colors:outline', 'transition duration-100 will-change-transform data-closed:translate-y-12 data-closed:opacity-0 data-enter:ease-out data-leave:ease-in sm:data-closed:translate-y-0 sm:data-closed:data-enter:scale-95'), transition: true, children: children })) }) })] })));
}
function DialogTitle(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)(Headless.DialogTitle, Object.assign({}, props, { className: (0, clsx_1.clsx)(className, 'text-balance text-2xl font-bold leading-tight text-neutral-900') }));
}
function DialogDescription(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)(Headless.Description, Object.assign({ as: text_1.Text }, props, { className: (0, clsx_1.clsx)(className, 'mt-2 text-pretty') }));
}
function DialogBody(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, clsx_1.clsx)(className, 'mt-6') }));
}
function DialogActions(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, clsx_1.clsx)(className, 'mt-8 flex flex-col-reverse items-center justify-end gap-3 *:w-full sm:flex-row sm:*:w-auto') }));
}
